module.exports = __webpack_public_path__ + "static/media/edu7.1384bf64.jpg";